import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import Text, { TYPES as txtTypes, SIZES as txtSizes } from 'components/elements/Text';
import './index.scss';

export const Options = ({ OptionsMap = [], onSelect, name }) => {
   return (
      <div className='SelectItem__options'>
         {OptionsMap.map((e) => {
            return (
               <div className='SelectItem__item' onClick={() => onSelect(e.value)} key={uuidv4()} role='presentation'>
                  <Text
                     type={txtTypes.regular}
                     size={txtSizes.xsmall}
                     style={name === 'emailCodes' ? {} : { userSelect: 'none' }}
                     inner={e.label}
                  />
               </div>
            );
         })}
         {OptionsMap.length === 0 && (
            <div className='SelectItem__item' style={{ textAlign: 'center' }}>
               <Text
                  type={txtTypes.regularDefault}
                  size={txtSizes.small}
                  style={name === 'emailCodes' ? { color: 'rgb(114, 121, 120)' } : { color: 'rgb(114, 121, 120)', userSelect: 'none' }}
                  inner='No item to select'
               />
            </div>
         )}
      </div>
   );
};

Options.propTypes = {
   OptionsMap: PropTypes.array,
   onSelect: PropTypes.func,
   name: PropTypes.string,
};
